import { inject, watch, type InjectionKey, type Ref } from 'vue';

export const nullsetterListenerSymbol = Symbol() as InjectionKey<Ref<boolean>>;

/**
 * This triggers the callback function if there is a NullSetter wrapping this component and the nullsetter is clicked
 */
export const useNullsetterListener = (callback: () => void) => {
    const listener = inject(nullsetterListenerSymbol, null);

    if (listener == null) {
        return;
    }

    watch(listener, () => {
        callback();
    });
};
